import { Injectable } from '@angular/core';
import { ValidLocale } from '@core/models/language.interface';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  constructor(
    private translate: TranslateService,
  ) { }

  getLocale (): ValidLocale {
    const currentLocale = localStorage.getItem('locale');
    return (currentLocale as ValidLocale) ||  'en';
  }

  setLocale(newLocale: ValidLocale) {
    localStorage.setItem('locale', newLocale);
    this.translate.setDefaultLang(newLocale);
    this.translate.use(newLocale || 'en');

    document.documentElement.setAttribute('dir', newLocale === 'ar' ? 'rtl' : 'ltr');
    document.documentElement.setAttribute('lang', newLocale);
  }

}
